// material-ui
import { Box, Typography } from '@mui/material';
import slogo from 'assets/images/users/slogo.png';

// ==============================|| LOGO MAIN (Image + Text) ||============================== //

export default function LogoMain() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <img
        src={slogo}
        alt="Social Media Hub"
        style={{ width: 32, height: 32, borderRadius: '4px' }}
      />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          color: 'text.primary',
          letterSpacing: 0.5
        }}
      >
        Social Media Hub
      </Typography>
    </Box>
  );
}
